import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { ForumPostRedirectPage } from '@/features/forum';

export const Route = createFileRoute('/forum_/post/$postId')({
  component: ForumPostRoute,
});

function ForumPostRoute(): ReactNode {
  const { postId } = Route.useParams();
  return <ForumPostRedirectPage postId={postId} />;
}
